/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listing_Status_Off_MarketInputs */

const en_listing_status_off_market = /** @type {(inputs: Listing_Status_Off_MarketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Off Market`)
};

const es_listing_status_off_market = /** @type {(inputs: Listing_Status_Off_MarketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retirado del mercado`)
};

const fr_listing_status_off_market = /** @type {(inputs: Listing_Status_Off_MarketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retiré du marché`)
};

const de_listing_status_off_market = /** @type {(inputs: Listing_Status_Off_MarketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicht auf dem Markt`)
};

const ja_listing_status_off_market = /** @type {(inputs: Listing_Status_Off_MarketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`販売停止`)
};

const zh_listing_status_off_market = /** @type {(inputs: Listing_Status_Off_MarketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已下架`)
};

const ar_listing_status_off_market = /** @type {(inputs: Listing_Status_Off_MarketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`خارج السوق`)
};

const id_listing_status_off_market = /** @type {(inputs: Listing_Status_Off_MarketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Di Luar Pasar`)
};

const it_listing_status_off_market = /** @type {(inputs: Listing_Status_Off_MarketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fuori Mercato`)
};

const ru_listing_status_off_market = /** @type {(inputs: Listing_Status_Off_MarketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Снято с продажи`)
};

const pt_listing_status_off_market = /** @type {(inputs: Listing_Status_Off_MarketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fora do Mercado`)
};

const ko_listing_status_off_market = /** @type {(inputs: Listing_Status_Off_MarketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`판매 중지`)
};

/**
* | output |
* | --- |
* | "Off Market" |
*
* @param {Listing_Status_Off_MarketInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const listing_status_off_market = /** @type {((inputs?: Listing_Status_Off_MarketInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listing_Status_Off_MarketInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listing_status_off_market(inputs)
	if (locale === "es") return es_listing_status_off_market(inputs)
	if (locale === "fr") return fr_listing_status_off_market(inputs)
	if (locale === "de") return de_listing_status_off_market(inputs)
	if (locale === "ja") return ja_listing_status_off_market(inputs)
	if (locale === "zh") return zh_listing_status_off_market(inputs)
	if (locale === "ar") return ar_listing_status_off_market(inputs)
	if (locale === "id") return id_listing_status_off_market(inputs)
	if (locale === "it") return it_listing_status_off_market(inputs)
	if (locale === "ru") return ru_listing_status_off_market(inputs)
	if (locale === "pt") return pt_listing_status_off_market(inputs)
	return ko_listing_status_off_market(inputs)
});